import React, { useCallback, useEffect, useState } from 'react'
// import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import { PDFDownloadLink } from '@react-pdf/renderer'

import { CircularProgress } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import moment from 'moment'
import 'moment/locale/es'
// moment.locale('es')

import NumberFormat from 'react-number-format'

import './vistaPrevia.css'
// import { fetchConToken, fetchConTokenFile } from '../../../helpers/fetch'
// import { ModalProgress } from '../../modals/ModalProgress'
import { PdfFile } from './PdfFile'

// import imgRejilla from './rejilla.svg'
import { VistaPreviaPrint } from './VistaPreviaPrint'

const VistaPrevia = ({ open, setOpen, dataPreview }) => {

    // console.log('--dataPreview--', dataPreview)

    const auth = useSelector(state => state.auth)
    const infoEmp = useSelector(state => state.general.info)
    const { listaTiposDocumentos, listaFormasPagos } = useSelector(state => state.general)
    const { razon_social, ruc, direccion, fono, sitio_web, url_foto } = infoEmp

    const infoGeneral = useSelector(state => state.general.detail)
    const { pdf_color_formato } = infoGeneral

    // const [progress, setProgress] = useState(false)
    const progress = false
    const [openPrint, setOpenPrint] = useState(false)

    const [docName, setDocName] = useState('')
    const [payFormsName, setPayFormsName] = useState('')

    // const [openPreviewOptions, setOpenPreviewOptions] = useState(false)
    const viewOptions = {
        ocultar_montos_items: false,
        ver_solo_subtotal_item: false,
        ver_solo_titulos: false,
        ver_total_con_impuestos: false
    }

    // const params = useParams()
    // const { budgetId: idPresupuesto } = params

    const { separacion_miles, separacion_decimales, simbolo, subtotal, descuento, monto_base, observaciones, total_compra, total_impuesto, impuesto_porcentaje, descuento_porcentaje, estado_validacion, tipo_gasto } = dataPreview

    const handleClose = () => {
        setOpen(false)
    };

    const descriptionElementRef = React.useRef(null)
    const { current: descriptionElement } = descriptionElementRef

    const getNames = useCallback(() => {
        const foundDocName = listaTiposDocumentos.find(t => t.id === dataPreview?.id_tipo_documento)
        setDocName(foundDocName?.nombre || '')

        const foundPayForms = listaFormasPagos.find(t => t.id === dataPreview?.id_forma_pago)
        setPayFormsName(foundPayForms?.nombre || '')
    }, [listaTiposDocumentos, listaFormasPagos, dataPreview])

    const handleDowload = async () => {
        document.getElementById(`btn-descargar-pdf`).click()
    }

    const handlePrint = async () => {
        setOpenPrint(true)
    }

    useEffect(() => {
        getNames()

        if (open) {

            if (descriptionElement !== null) {
                descriptionElement.focus()
            }
        }
    }, [open, descriptionElement, getNames])

    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia'
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle
                    className='ColorTitleDocument'
                    id="scroll-dialog-title">

                    <div>
                        <label>Vista previa</label>
                    </div>

                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className='DialogContentVistaPrevia'>

                    {(estado_validacion === 'por validar' || estado_validacion === 'requiere' || estado_validacion === 'solicitado') &&
                        < div className='copia-no-valida'>
                            <h2>Copia no válida</h2>
                            <h3>( compra pendiente de validar )</h3>
                        </div>
                    }

                    <div className='ContainerPresupuesto'>
                        <section className='Section1Presupuesto'>
                            <section>
                                <div>
                                    <div>
                                        {pdf_color_formato ?
                                            <h1 className='TitleModal' style={{ color: pdf_color_formato, textTransform: 'uppercase' }}>
                                                {tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}
                                            </h1>
                                            :
                                            <h1 className='ColorPrimary TitleModal' style={{ textTransform: 'uppercase' }}>
                                                {tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}
                                            </h1>
                                        }
                                        {/* <h1 className='ColorPrimary TitleModal'>
                                            {tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}
                                        </h1> */}
                                        <p className='SubTitle ColorTitleDocument '>{`#0000${dataPreview.numero}`}</p>
                                    </div>

                                    <div style={{ position: 'relative' }}>
                                        <section className='ContainerLogoEmpresa'>
                                            <img
                                                src={url_foto}
                                                alt="Logo empresa"
                                            />
                                        </section>
                                    </div>

                                </div>

                                <p className='SubTitle ColorTitleDocument '>{moment(new Date()).format('DD MMMM YYYY')}</p>
                                <section className='InfoGeneralPpto'>
                                    <div>
                                        <p>Proveedor: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{dataPreview?.razon_social || 'N/A'}</p>
                                    </div>
                                    <div>
                                        <p>RUC: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{dataPreview?.ruc || 'N/A'}</p>
                                    </div>
                                    <div>
                                        <p>Documento: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{docName || 'N/A'}</p>
                                    </div>
                                    <div>
                                        <p>Enviado por: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{`${auth.name || 'Nombre'} / ${auth.email || 'N/A'}`}</p>
                                    </div>
                                </section>

                            </section>

                        </section>
                        <section className='Section2Presupuesto'>
                            <section>
                                <h1 className='ColorTitleDocument TitleSection2 Uppercase'>{dataPreview.referencia}</h1>
                                <section className='InfoGeneralPpto'>

                                    <TablaItems
                                        dataPreview={dataPreview}
                                        viewOptions={viewOptions}
                                    />

                                    <section className='row InfoFinalPpto'>

                                        <div className='col-7'></div>
                                        <div className='col-5 p-bloque-total'>

                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'><label className='p-label-total'>SUBTOTAL</label></div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={subtotal}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            ( {descuento_porcentaje}% )<span className='ms-2'>DESC</span>
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={descuento}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            <div className='row'>
                                                <div className='col-6'><label className='p-label-total'>TOTAL BASE</label></div>
                                                <div className='col-6'>
                                                    <NumberFormat
                                                        className='p-label-total-monto'
                                                        value={monto_base}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-6'>
                                                    <label className='p-label-total'>
                                                        ( {parseFloat(impuesto_porcentaje).toFixed(0)}% )<span className='ms-2'>IGV</span>
                                                    </label>
                                                </div>
                                                <div className='col-6'>
                                                    <NumberFormat
                                                        className='p-label-total-monto'
                                                        value={total_impuesto}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-6'><label className='p-label-total'>TOTAL</label></div>
                                                <div className='col-6'>
                                                    <NumberFormat
                                                        className='p-label-total-monto'
                                                        value={total_compra}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </section>
                                </section>
                            </section>
                        </section>
                        <section className='Section3Presupuesto'>

                            {pdf_color_formato ?
                                <h1
                                    className='ColorTitleDocument TitleSection2'
                                    style={{
                                        borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)',
                                        paddingBottom: '5px',
                                        fontWeight: '600',
                                        marginTop: '7px'
                                    }}
                                >CONDICIONES</h1>
                                :
                                <h1 className='ColorTitleDocument TitleSection2 TitleSection3'>CONDICIONES</h1>
                            }

                            <section>
                                <div className='ObservacionesPpto'>
                                    <div>
                                        <p>Forma de pago: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{payFormsName || ''}</p>
                                    </div>

                                    {observaciones &&
                                        <div>
                                            <p>Observaciones: </p>
                                            <p style={{ textTransform: 'uppercase' }}>
                                                <pre>{observaciones || ''}</pre>
                                            </p>
                                        </div>
                                    }

                                </div>
                            </section>
                        </section>
                        <section className='Section4Presupuesto mt-4'>

                            {pdf_color_formato ?
                                <h1
                                    className='ColorTitleDocument TitleSection2'
                                    style={{
                                        borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)',
                                        paddingBottom: '5px',
                                        fontWeight: '600',
                                        marginTop: '7px'
                                    }}
                                >DATOS DE FACTURACIÓN</h1>
                                :
                                <h1 className='ColorTitleDocument TitleSection2 TitleSection4'>DATOS DE FACTURACIÓN</h1>
                            }

                            <section>
                                <div className='DatosEmpresa'>
                                    <div>
                                        <p>Razón social: </p>
                                        <p>{razon_social || 'ninguno'}</p>
                                    </div>
                                    <div>
                                        <p>RUC: </p>
                                        <p>{ruc || 'ninguno'}</p>
                                    </div>
                                    <div>
                                        <p>Dirección: </p>
                                        <p>{direccion || 'ninguno'}</p>
                                    </div>
                                    <div>
                                        <p>Teléfono: </p>
                                        <p>{fono || 'ninguno'}</p>
                                    </div>
                                    <div>
                                        <p>Página web: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{sitio_web || 'ninguno'}</p>
                                    </div>
                                </div>
                            </section>
                        </section>
                    </div>
                </DialogContent>

                {(estado_validacion === 'validado' || estado_validacion === '' || estado_validacion === null) &&
                    <DialogActions className='DialogActionVistaPrevia'>
                        <Button
                            className='p-btn-secondary'
                            variant="contained"
                            size='medium'
                            type='button'
                            onClick={handleDowload}
                        >
                            Descargar
                            {progress && <CircularProgress className='CircularProgress' />}
                        </Button>

                        <Button
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='button'
                            onClick={handlePrint}
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                }

                {openPrint &&
                    <VistaPreviaPrint
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={{
                            ...dataPreview,
                            payFormsName: payFormsName,
                            docName: docName
                        }}
                        viewOptions={viewOptions}
                        open={openPrint}
                        setOpen={setOpenPrint}
                        urlLogo={url_foto}
                        infoGeneral={infoGeneral}
                    />
                }

                <div style={{ display: 'none' }}>
                    <PDFDownloadLink
                        document={
                            <PdfFile
                                auth={auth}
                                infoEmp={infoEmp}
                                dataPreview={{
                                    ...dataPreview,
                                    payFormsName: payFormsName,
                                    docName: docName
                                }}
                                viewOptions={viewOptions}
                                urlLogo={url_foto}
                                infoGeneral={infoGeneral}
                            />
                        }
                        fileName="orden_compra.pdf"
                    >
                        <button id="btn-descargar-pdf" type="button">descargar</button>
                    </PDFDownloadLink>

                </div>
            </Dialog>
        </div >
    );
}

export default VistaPrevia

const TablaItems = ({ dataPreview, viewOptions }) => {

    const { separacion_miles, separacion_decimales, simbolo } = dataPreview
    const { pdf_color_formato } = useSelector(state => state.general.detail)

    return (
        <table className="table table-vista-previa">
            <thead>
                <tr
                    className='text-center'
                    style={{ borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)' }}
                >
                    <th scope="col" className='text-start'>Ítems</th>
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col">Cant.</th>}
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col">Días</th>}
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col" className='text-end'>P. Unitario</th>}
                    {!viewOptions.ocultar_montos_items && <th scope="col" className='text-end'>Subtotal</th>}
                </tr>
            </thead>
            <tbody>
                {dataPreview?.items?.map((it) => {
                    return (
                        <tr className='text-center title' key={it.id}>
                            <td className='text-start'>{it.nombre}</td>
                            <td>{it.cantidad}</td>
                            <td>{it.dias}</td>
                            <td className='text-end'>
                                <NumberFormat
                                    value={it.precio_unitario || 0}
                                    displayType={'text'}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                />
                            </td>
                            <td className='text-end'>
                                <NumberFormat
                                    value={it.subtotal || 0}
                                    displayType={'text'}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                />
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}